import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
// import { TextFieldHookForm } from '../../../../../../../layout/H2ookFormInputs';

import { AgGridColumn, AgGridReact } from "ag-grid-react";

import {
} from "../../../../../layout/HookFormInputs";
import {

  getVersioningListingDataService,
} from "../../../Action";
import { useLocation } from "react-router-dom";
import DayTime from "../../../../../common/DayTimeWrapper";
import { defaultPageSize } from "../../../../../../config/constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const VersionListing = () => {
  const [globalTake, setGlobalTake] = useState(defaultPageSize);
  const [versionListData, setVersionListData] = useState([]);
  const location = useLocation();

  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const idData = searchParams.get("VendorRequirementRegistrationId");
  const nsaAuditDetailId = searchParams.get("nsaAuditDetailId");
  useEffect(() => {
    getVersioningListingData(idData, nsaAuditDetailId);
  }, [idData]);
  const getVersioningListingData = (
    vendorRequirementRegistrationId,
    nsaAuditDetailId
  ) => {
    getVersioningListingDataService(
      vendorRequirementRegistrationId,
      nsaAuditDetailId
    )
      .then((res) => {
        setVersionListData(res?.Data);
      })
      .catch(() => { });
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,

    // headerCheckboxSelection: (isSimulation || props?.benchMark) ? isFirstColumn : false,
    headerCheckboxSelectionFilteredOnly: true,
    // checkboxSelection: isFirstColumn
  };
  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const nsaAuditDetailId = props?.data?.NSAAuditDetailId;
    // const handleDeletePopup = () => {
    //   // Set loader to true to indicate delete operation is in progress
    //   setCftLoading(true);

    //   deleteAssifnCft(props?.data?.id, (error, response) => {
    //     // Set loader to false once the delete request is complete
    //     setCftLoading(false);

    //     if (error) {
    //       console.error("Error deleting business type:", error);
    //       Toaster.error(error?.response?.data?.ErrorMessage);
    //       // Handle the error as needed
    //     } else {
    //       Toaster.success(response?.data?.Data?.Message);
    //       // Fetch updated data after deletion
    //       getUsers(parseInt(nsaAuditDetailId), parseInt(idData)); // Fetch updated data
    //     }
    //   });
    // };
    const handleView = () => {

      // Handle edit action
      // history.push(`/add-business-type?id=${requestId}&mode2=edit`);
      history.push(
        `/view-supplier-need-form?VendorRequirementRegistrationId=${idData}&nsaAuditDetailId=${nsaAuditDetailId}`
      );
    };
    const toggleModal = () => { };

    return (
      <div>
        <button
          title="View"
          className="View hl-delete-icon"
          type="button"
          onClick={handleView}
        ></button>
      </div>
    );
  };
  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };
  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    // customFloatingFilter: CustomDateRangeFilter,
    // statusButtonFormatter: statusButtonFormatter,
    // onFilterChanged: onFilterChanged,
    effectiveDateFormatter: effectiveDateFormatter,
    // hyphenFormatter: hyphenFormatter,
    // customNoRowsOverlay: NoContentFound,
    // checkBoxRenderer: checkBoxRenderer,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };
  return (
    <Row className="ag-grid-react">
      <Col>
        <div className={`ag-grid-wrapper`}>
          <div className={`ag-theme-material`}>
            <AgGridReact
              style={{ height: "100%", width: "100%" }}
              floatingFilter={true}
              defaultColDef={defaultColDef}
              domLayout="autoHeight"
              rowData={versionListData ? versionListData : []}
              rowSelection={"multiple"}
              pagination={false}
              enableBrowserTooltips={true}
              frameworkComponents={frameworkComponents}
              // pagination={true}
              paginationPageSize={globalTake}
              pivotPanelShow={"always"}
              paginationAutoPageSize={true}
            >
              <AgGridColumn
                headerName="S. No."
                field="serialNumber"
                floatingFilter={false}
                sortable={false}
                valueGetter={(params) => params.node.rowIndex + 1}
              ></AgGridColumn>

              <AgGridColumn
                cellClass="has-checkbox"
                field="ResubmittedOn"
                floatingFilter={false}
                headerName="Resubmitted On"
              // cellRenderer={checkBoxRenderer}
              ></AgGridColumn>

              <AgGridColumn
                field="RequestedOn"
                floatingFilter={false}
                headerName="Requested On"
                valueFormatter={(params) => {
                  const cellValue = params.value;
                  return cellValue
                    ? DayTime(cellValue).format("DD/MM/YYYY")
                    : "";
                }}
              // cellRenderer={checkBoxRenderer}
              ></AgGridColumn>

              <AgGridColumn
                field="RequestedBy"
                floatingFilter={false}
                headerName="Requested By"
              // cellRenderer={checkBoxRenderer}
              ></AgGridColumn>

              <AgGridColumn
                headerName="Initial Submission"
                sortable={false}
                field="InitialSubmissionDate"
                floatingFilter={false}
                valueFormatter={(params) => {
                  const cellValue = params.value;
                  return cellValue
                    ? DayTime(cellValue).format("DD/MM/YYYY")
                    : "";
                }}
              ></AgGridColumn>
              <AgGridColumn
                headerName="Action"
                sortable={false}
                cellRenderer={"totalValueRenderer"}
                type="rightAligned"
                floatingFilter={false}
              // tooltipComponent={'customTooltip'}
              ></AgGridColumn>
            </AgGridReact>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default VersionListing;
